import React from 'react';
import { Dialog } from 'primereact/dialog';

/**
 * MessageBox — small reusable confirmation dialog.
 *
 * Visual styling lives in /public/styles.css under `.likkan-messagebox`.
 * The severity (warning / danger / info / success) drives which tinted
 * background the OK button picks up via a `.severity-<type>` modifier.
 */
const MessageBox = ({ visible, title, content, type = 'warning', onHide }) => {
  return (
    <Dialog
      visible={visible}
      onHide={onHide}
      header={title}
      className={`likkan-messagebox severity-${type}`}
      modal
      dismissableMask
    >
      <div className="likkan-messagebox-body">{content}</div>
      <div className="likkan-messagebox-footer">
        <button className="likkan-messagebox-button" onClick={onHide}>
          確定
        </button>
      </div>
    </Dialog>
  );
};

export default MessageBox;
